import React from 'react';

import { Link } from 'gatsby';

import { Section } from '../Section';
import { Button } from '../web';

interface BottomCtaProps {
  title: string;
  subtitle: string;
  ctaText: string;
  ctaLink: string;
  ctaCallback?: () => void;
  bgClassName?: string;
}

const BottomCta = (props: BottomCtaProps) => {
  return (
    <Section
      bgClassName={
        props.bgClassName ? props.bgClassName : classNames.bgClassName
      }
      className={classNames.container}
    >
      <h1 className={classNames.title}>{props.title}</h1>
      <h2 className={classNames.subtitle}>{props.subtitle}</h2>
      <Link to={props.ctaLink}>
        <Button
          preset="primary"
          text={props.ctaText}
          onClick={props.ctaCallback}
        />
      </Link>
    </Section>
  );
};

const classNames = {
  bgClassName: ['tw-bg-space'].join(' '),
  container: ['tw-items-center', 'tw-justify-center', 'tw-text-center'].join(
    ' ',
  ),
  title: ['tw-display2-teodor', 'tw-text-white', 'tw-mb-[24px]'].join(' '),
  subtitle: ['tw-h3', 'tw-text-white', 'tw-mb-[48px]'].join(' '),
};

export { BottomCta };
